// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invert-tr {
  display: flex;
  flex-direction: column;
  float: left;
}
.invert-th,
.invert-td {
  display: flex;
}

.table {
  border-radius: 0.5rem;
  border-top: 1px solid #b9b9b9;
  border-left: 1px solid #b9b9b9;
  border-right: 1px solid #b9b9b9;

  font-family: "WMFT-Regular";
  font-size: 1.25rem;
  width: 90%;
  align-self: center;
}

.table-tr {
  display: flex;
  border-bottom: 1px solid #b9b9b9;
}

.table-td-bold {
  font-family: "WMFD-ExtraBold";
  color: var(--secondary-color);
  text-align: center;
  border-right: 1px solid #b9b9b9;
  padding: 1rem;
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1 1;
}

.table-td-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 5rem;
  width: 5rem;
  border: 1px solid #b9b9b9;
  border-radius: 50%;
  font-size: 1.5rem;
  font-family: "WMFD-ExtraBold";
  color: var(--secondary-color);
}

.table-td {
  padding: 1rem;
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1 1;
}

@media (max-width: 650px) {
  .table {
    border-bottom: 1px solid #b9b9b9;
  }
  .table-tr {
    flex-direction: column;
    padding: 0.5rem 1rem;
  }

  .table-tr > p {
    text-align: center;
  }

  .table-td-circle {
    height: 3.5rem;
    width: 3.5rem;
    font-size: 1.25rem;
  }

  .table-td-bold {
    border-bottom: 1px solid #b9b9b9;
    border-right: 0px;
  }

  .table-td {
    border-right: 0px;
  }

  .table {
    display: flex;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Tables.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;;EAE/B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAO;AACT;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".invert-tr {\r\n  display: flex;\r\n  flex-direction: column;\r\n  float: left;\r\n}\r\n.invert-th,\r\n.invert-td {\r\n  display: flex;\r\n}\r\n\r\n.table {\r\n  border-radius: 0.5rem;\r\n  border-top: 1px solid #b9b9b9;\r\n  border-left: 1px solid #b9b9b9;\r\n  border-right: 1px solid #b9b9b9;\r\n\r\n  font-family: \"WMFT-Regular\";\r\n  font-size: 1.25rem;\r\n  width: 90%;\r\n  align-self: center;\r\n}\r\n\r\n.table-tr {\r\n  display: flex;\r\n  border-bottom: 1px solid #b9b9b9;\r\n}\r\n\r\n.table-td-bold {\r\n  font-family: \"WMFD-ExtraBold\";\r\n  color: var(--secondary-color);\r\n  text-align: center;\r\n  border-right: 1px solid #b9b9b9;\r\n  padding: 1rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex;\r\n  flex: 1;\r\n}\r\n\r\n.table-td-circle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  height: 5rem;\r\n  width: 5rem;\r\n  border: 1px solid #b9b9b9;\r\n  border-radius: 50%;\r\n  font-size: 1.5rem;\r\n  font-family: \"WMFD-ExtraBold\";\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.table-td {\r\n  padding: 1rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex;\r\n  flex: 1;\r\n}\r\n\r\n@media (max-width: 650px) {\r\n  .table {\r\n    border-bottom: 1px solid #b9b9b9;\r\n  }\r\n  .table-tr {\r\n    flex-direction: column;\r\n    padding: 0.5rem 1rem;\r\n  }\r\n\r\n  .table-tr > p {\r\n    text-align: center;\r\n  }\r\n\r\n  .table-td-circle {\r\n    height: 3.5rem;\r\n    width: 3.5rem;\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .table-td-bold {\r\n    border-bottom: 1px solid #b9b9b9;\r\n    border-right: 0px;\r\n  }\r\n\r\n  .table-td {\r\n    border-right: 0px;\r\n  }\r\n\r\n  .table {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
